import { DisplayTraceabilityDto } from '../../../shared/traceability/display-traceability.dto';

export class ContractDto {
  constructor(
    public id: number,
    public beginDate: Date,
    public endDate: Date,
    public contractType: string,
    public mainPurpose: string,
    public status: string,
    public achievement: string,
    public project: string,
    public actionsToPerform: string,
    public statusDate: Date,
    public idBeneficiary: number,
    public traceability?: DisplayTraceabilityDto[],
  ) {}

  public static fromJson(json: any): ContractDto {
    return new ContractDto(
      json.id,
      json.beginDate ? new Date(json.beginDate) : undefined,
      json.endDate ? new Date(json.endDate) : undefined,
      json.contractType,
      json.mainPurpose,
      json.status,
      json.achievement,
      json.project,
      json.actionsToPerform,
      json.statusDate ? new Date(json.statusDate) : undefined,
      json.idBeneficiary,
      json.traceability,
    );
  }
}
